var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sign-page',{attrs:{"title-text":"职称聘任记录","request":_vm.request,"table-size":"large","column-list":_vm.columnList,"title-menus":_vm.titleMenus,"tableActions":_vm.tableActions,"dealFormData":_vm.dealFormData,"form-parms-add":_vm.formParmsAdd,"tableActionsFixed":true,"form-parms-update":_vm.formParmsUpdate,"need-data-file":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }